module.exports = __webpack_public_path__ + "static/media/netflix.411b99ec.svg";